import {RSS_API_URL} from '../constants';

/** Turn a stored path (`uploads/posts/…`) or data URL / absolute URL into a usable `img` `src`. */
export function resolvePostImageSrc(pathOrUrl: string): string {
  const s = (pathOrUrl || '').trim();
  if (!s) return '';
  if (s.startsWith('data:') || /^https?:\/\//i.test(s)) return s;
  return `${RSS_API_URL}/${s.replace(/^\//, '')}`;
}
